var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "step-wrap" },
    [
      _vm._l(_vm.steps, function (item, index) {
        return [
          _c("div", { key: index, staticClass: "step-item" }, [
            _c(
              "span",
              { staticClass: "number", class: { active: index < _vm.active } },
              [_vm._v(_vm._s(index + 1))]
            ),
            _c(
              "p",
              { staticClass: "title", class: { active: index < _vm.active } },
              [_vm._v(_vm._s(item))]
            ),
          ]),
          index < _vm.steps.length - 1
            ? _c("div", {
                key: item + index,
                staticClass: "line",
                class: { active: index + 1 < _vm.active },
              })
            : _vm._e(),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }